export class JSONRpc {
	jsonrpc: string
	method: string
	id: string
	params: any
	constructor(options: {
		jsonrpc?: string,
		method?: string,
		id?: string,
		params?: any
	} = {}) {
		this.jsonrpc = options.jsonrpc || ''
		this.method = options.method || ''
		this.id = options.id || this.newGuid()
		this.params = options.params || {}
	}
	newGuid() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0,
				v = c == 'x' ? r : (r & 0x3 | 0x8)
			return v.toString(16)
		})
	}
}
